let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j5COe")).then(() => parcelRequire('3p9an'));